// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderTooltip_root__hXjaB","text":"HeaderTooltip_text__2E-rJ","topPlacement":"HeaderTooltip_topPlacement__11elo","bottomPlacement":"HeaderTooltip_bottomPlacement__1QsDK"};